import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { useLayout } from '@swf/sports/providers/LayoutProvider';

import type { Props as HorizontalMenuItemProps } from '../HorizontalMenuItem/HorizontalMenuItem';
import HorizontalMenuItem from '../HorizontalMenuItem/HorizontalMenuItem';

import { TXTWCL_Close, TXTWCL_Sports } from './SportsMenuToggleButton.messages.json';
import styles from './SportsMenuToggleButton.scss';

type Props = Partial<HorizontalMenuItemProps>;

const SportsMenuToggleButton: React.FC<Props> = () => {
  const { showNavigationSection, setShowNavigationSection } = useLayout();

  return (
    <HorizontalMenuItem
      icon={showNavigationSection ? 'close-small' : 'sports-menu'}
      key="sports-menu"
      onClick={() => {
        setShowNavigationSection(!showNavigationSection);
      }}
      text={
        showNavigationSection ? (
          <Translation {...TXTWCL_Close} />
        ) : (
          <Translation {...TXTWCL_Sports} />
        )
      }
      className={classNames(styles.sportsMenuToggleButton, {
        [styles.open]: showNavigationSection
      })}
    />
  );
};

export default SportsMenuToggleButton;
